// @flow
import GenericSlider from '@components/sliders/GenericSlider';

import type { ColorSearchFilterType } from '@types/search';
import type { OnSliderUpdateType } from '@components/containers/Diamonds';

import QuestionMarkPopup from '@components/popups/QuestionMark';
import * as ColorContent from '@components/popups/content/Color';

const steps = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K-M'];
const baseSliderOpts = {
  range: {
    min: 0,
    max: steps.length
  },
  step: 1,
  margin: 1,
  connect: [false, true, false]
};

function getStartValues(stateValues = []) {
  if (stateValues.length === 0) return [0, steps.length];

  let min = steps.length; // start at the max possible
  let max = 0; // start at the min possible

  stateValues.forEach(value => {
    const index = steps.indexOf(value);
    if (min > index) min = index;
    if (max < index) max = index;
  });

  return [min, max + 1];
}

type PropsType = {
  onSliderUpdate: OnSliderUpdateType,
  value: ColorSearchFilterType | void
};

type StateType = {
  showPopup: boolean
};

const Popup = () => <QuestionMarkPopup initialContent={ColorContent} />;

export default class ColorSlider extends React.Component<PropsType, StateType> {
  state = {
    showPopup: false
  };

  showPopup = () => {
    if (!this.state.showPopup) this.setState({ showPopup: true });
  };

  render() {
    const sliderOpts = {
      ...baseSliderOpts,
      start: getStartValues(this.props.value)
    };

    return (
      <GenericSlider
        title={'Color'}
        sliderMarginTop={'0'}
        titleMarginBottom={'2px'}
        sliderOpts={sliderOpts}
        onSliderUpdate={steps =>
          this.props.onSliderUpdate('UPDATE_COLOR', steps)
        }
        steps={steps}
        Popup={Popup}
      />
    );
  }
}
